import { RoleLevelEnum } from '@/enums';
import { useGetMe } from '@/hooks/useGetProfileQuery';
import { PRIVATE_ROUTES } from '@/routes/routes';
import { notification } from 'antd';
import { useCallback, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const TRIGGER_COUNT = 6;
const RESET_DELAY_MS = 1500;

export const useGodModeHotkey = () => {
  const { data: user } = useGetMe();
  const navigate = useNavigate();
  const countRef = useRef(0);
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  const isSuperAdmin = user?.mainRole?.level === RoleLevelEnum.SUPER_ADMIN;

  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (!isSuperAdmin || e.key !== '.') {
        countRef.current = 0;
        return;
      }

      clearTimeout(timerRef.current);
      countRef.current += 1;

      if (countRef.current >= TRIGGER_COUNT) {
        countRef.current = 0;
        sessionStorage.setItem('godmode_unlocked', 'true');
        notification.open({
          message: '⚡ God Mode',
          description: 'Click to open the org creation panel.',
          key: 'god-mode',
          onClick: () => {
            navigate(PRIVATE_ROUTES.GOD_MODE);
            notification.destroy('god-mode');
          },
          style: { cursor: 'pointer' },
          duration: 5,
        });
      } else {
        timerRef.current = setTimeout(() => {
          countRef.current = 0;
        }, RESET_DELAY_MS);
      }
    },
    [isSuperAdmin, navigate],
  );

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      clearTimeout(timerRef.current);
    };
  }, [handleKeyDown]);
};
